import _ from 'lodash'
export default confirmCtrl

/** @ngInject */
function confirmCtrl($scope, $state, $stateParams, $q, User, DeviceChecker, ContactTelephone, ErrorCatcher, userInfo, ContractDraft, ContractService, ApiService) {
    $scope.password = ''
    $scope.passwordCheck = ''
    $scope.passwordStrengh = undefined
    $scope.hasUserInfo = userInfo.hasUserInfo
    $scope.currentInput = 'password'
    $scope.passwordType = 'password'
    $scope.isMobile = DeviceChecker.isMobile
    $scope.contactTelephone = ContactTelephone
    $scope.isSubmitting = false
    $scope.error = {
        confirm: false,
    }
    $scope.confirmForm = {
        form1: {
            $invalid: false,
        }, // Need to do it due to weird behavior
    }
    $scope.minStrength = 2
    $scope.scoreMeaning = [
        'Trop simple',
        'Encore un petit effort',
        'Acceptable',
        'Très bien',
        'Top !',
    ]

    $scope.togglePasswordVisibility = () => {
        $scope.passwordType = $scope.passwordType === 'password' ? 'text' : 'password'
    }

    $scope.focus = function (input) {
        $scope.currentInput = input
        if (input !== 'password') {
            $scope.error.confirm = false
        }
        if (input !== '') {
            return $scope.confirmForm.form1.$setPristine()
        }
    }

    $scope.passwordStrengh = undefined

    $scope.setPassword = function (password, passwordCheck) {
        $scope.error.confirm = false
        $scope.confirmForm.form1.$setSubmitted()
        if ($scope.confirmForm.form1.$invalid) {
            return
        }

        $scope.isSubmitting = true
        const setPassword$ = User.setPassword({ token: $state.params.token }, { password, passwordCheck }).$promise
        setPassword$
        .then((user) => {
            const userInfoData = ApiService.fetchUserInfo()
            const contractDraft = ContractDraft.get({ create: false, silent: true }).$promise
            return $q.all({ userInfo: userInfoData, contractDraft })
        })
        .then((values) => {
            // Get redirectTo + source
            const { redirectTo, source } = localStorage

            localStorage.removeItem('subscriptionToken')
            localStorage.removeItem('redirectTo')
            localStorage.removeItem('source')

            // Redirect rules
            if (!_.isEmpty(ContractService.findFirstGoalNotDefinedContract(values.userInfo.contracts))) {
                return $state.go('endSubscription')
            } else if ($stateParams.redirectTo === 'endSubscription') {
                return $state.go($stateParams.redirectTo, $stateParams)
            } else if (values.contractDraft.ready_to_checkout) {
                return $state.go('subscriptionSummary')
            } else if (source === 'communaute') {
                if ((redirectTo !== undefined) && (redirectTo !== 'undefined')) {
                    window.location.href = `/communaute${redirectTo}`
                }
                return $state.go('community')
            } else if ((redirectTo !== undefined) && (redirectTo !== 'undefined')) {
                return $state.go(redirectTo)
            }
            const unpaidContract = ContractService.findFirstUnpaidContract(values.userInfo.contracts)
            if (!_.isEmpty(unpaidContract)) {
                return $state.go('invoice', { contractId: unpaidContract.id })
            }
            const selectedContract = ContractService.findFirstNotFinishedContract(values.userInfo.contracts)
            if (!_.isEmpty(selectedContract)) {
                return $state.go('account', { contractId: selectedContract.id })
            }
            if (_.isEmpty(values.userInfo.contracts)) {
                return $state.go('subscription', { bulk_purchase: $stateParams.bulk_purchase })
            }
            return $state.go('account')
        }).catch((error) => {
            if (!error.message === 'transition prevented') {
                return ErrorCatcher.catchError(error)
            }
        })

        return setPassword$.catch((error) => {
            $scope.isSubmitting = false
            $scope.error.confirm = true
            return ErrorCatcher.catchError(error)
        })
    }

    const activate = function () {
        require(['zxcvbn'], (zxcvbn) => {
            $scope.updatePasswordStrength = (password) => {
                console.log('updatePasswordStrength was triggered')
                $scope.passwordStrengh = password ? zxcvbn(password).score : undefined
            }
            $scope.$watch('password', (newValue, oldValue) => {
                console.log('password change was triggered')
                $scope.passwordStrengh = newValue ? zxcvbn(newValue).score : undefined
            })
        })

        if (localStorage.source !== undefined) {
            $scope.fromCommunity = true
        }
    }

    return activate()
}



// WEBPACK FOOTER //
// ./src/states/confirm/confirm.js